var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DefaultPageLayout',[_c('section',{staticClass:"payment-methods"},[_c('CheckoutCard',{attrs:{"showDetails":false,"isolate":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }